<template>
    <div class="barra-lateral-esquerdo">
        <figure @click='deslogar' class="figure-image">
            <div v-if="getDeslog" class="backGroundOrangeRed">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Deslogado</figcaption>
            </div>
            <div v-else class="backgroundGreen">
                <img src="/imgs/icons/power-white.svg" class="img">
                <figcaption>Logado</figcaption>
            </div>
        </figure>

        <figure @click='messages' class='figure-image messagesChange'>
            <div :class="{'bg-adv': getMessages}">
                <div class="remove-padding">
                    <img src="/imgs/icons/chat-square-text-white.svg" class='img' alt="msg">
					<div class="remove-padding" v-if="(getTotalInQueue > 0 && !getMessages)">
						<span class="num">{{ getTotalInQueue }}</span>
					</div>
                </div>
                <figcaption>Atendimento Online</figcaption>
            </div>
        </figure>

		<figure @click="contacts()" class='figure-image'>
			<div :class="{'bg-adv': getContacts}">
				<img src="/imgs/icons/address-book.svg" class='img'>
				<figcaption>Contatos</figcaption>
			</div>
    	</figure>

		<figure  @click="historicol()" class='figure-image'>
			<div :class="{'bg-adv': getShowHistory}">
				<img src="/imgs/icons/arrow-counterclockwise-white.svg" class='img'>
				<figcaption>Histórico</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" class='figure-image'>
            <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Desligar</figcaption>
            </div>
            <div v-else @click="discar">
                <img src="/imgs/icons/telephone-forward-white.svg" class='img' alt="">
                <figcaption>Discar</figcaption>
            </div>
        </figure>

		<figure v-if="telefone" @click="pause" class="figure-image">
			<div v-if='getPause' class="backGroundOrange">
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
			</div>
			<div v-else>
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>Pausar</figcaption>
			</div>
		</figure>

		<figure v-if="telefone" @click="mute" class='figure-image'>
			<div v-if='getMute' class="backGroundOrange">
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mudo</figcaption>
			</div>
			<div v-else>
				<img src='/imgs/icons/mute-white.svg' class='img' alt="">
				<figcaption>Mute</figcaption>
			</div>
		</figure>

        <figure @click='agendamento' class='figure-image' style="display:none">
            <div class="">
                <img src="/imgs/icons/calendar-date-white.svg" class='img'>
                <figcaption>Agendamento</figcaption>
            </div>
        </figure>
       	<div hidden>{{hue}}</div>
    </div>

</template>

<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
	import clientData from '../../store/modules/newConnectLine';
	import {
		commercialsICampaigns,
		commercialsIICampaigns,
		commercialsIIICampaigns,
	} from './utils/campaigns_constants.js';

	const parsedTelefone = (process.env.MIX_TELEFONE === 'true');
	const isSSL = (location.hostname == 'localhost')? 'http': 'https';
	const connection = (parsedTelefone) ? io.connect(`${isSSL}://${location.hostname}:3002/`) : { 'on': function() {}, 'emit': function() {} };	
    
	export default {
    data() {
        return {
            interval_pause: '',
            time_pause: '',
            time_pause_format: '00:00:00',
            debugDisc: false,
            total_in_queue: '',
            queuesEsquerdo: false,
	        queuePause: false,
			telefone: parsedTelefone,
			statusList: [],
			break: '',
			selectedOption: "",
			contactDono: "",
			observacao: "",
			isBlinking: false,
			redFlag: false,

			hangupObj: {
				dados: [],
				uniqueid: "",
				callerIdNum: "",

			},
			ramal: user.getExtension(),
			// Campanhas de ligação: marca se o cliente atendeu, para decidir se a
			// ligação recebe a tabulação automática de "não atendido".
			campaignClientAnswered: false,
			// IDs de at_option_status que representam "não atendido" (rediscagem)
			// e agendamento, resolvidos pelo backend.
			redialTabs: [],
			scheduleTabs: [],
        }
    },
    computed: {
        ...mapGetters([
            'getDeslog',
            'getModalPause',
            'getMessages',
            'getOccurrences',
            'getShowHistory',
            'getCnpj',
            'getPause',
            'getMute',
            'getQueues',
            'getExtension',
            'getId',
            'getChannel',
            'getChamada',
            'allClients',
            'getShowSpearhead',
            'getProtocol',
            'getCallTime',
            'getPauseTime',
            'oneClient',
            'getShowBarRight',
            'getTotalMyQueue',
            'getTotalInQueue',
			'getContacts',
			'getCalendar',
			'getMotivoPause',
			'getShowCommercialICampaign',
			'getShowCommercialIICampaign',
			'getShowCommercialIIICampaign',
			'getShowAnyCommercialCampaign',
			'getCallData',
        ]),

        hue: function() {
            this.setExtension(user.getExtension())
            this.setQueues(user.getQueue())
            this.setId(user.getId())
        },
    },
    watch: {
        getPauseTime: function() {
            this.validateTimePause();
        },
        time_pause: function () {
            this.time_pause_format = moment.utc(this.time_pause * 1000).format('HH:mm:ss')
        },
		getDeslog(value) {
			if (!value) {
				if (!this.getMessages) {
					this.setMessage();
				}
			} 
			else {
				if (this.getMessages) {
					this.setMessage();
				}
			}
		}
    },
	created() {
		if (!this.getDeslog) this.setMessage();
		if(this.telefone) return;

		this.setDeslog();
		this.startOrOut();
	},
    methods: {
		...mapActions([
			'selectPause',
			'sendPauseApi',
			'setOccurrences',
			'setShowHistory',
			'setModalPause',
			'setModalSchedule',
			'settModalCall',
			'setMessage',
			'fetchOcurrences',
			'fetchPauses',
			'comeBack',
			'setDeslog',
			'startOrOut',
			'setMute',
			'setExtension',
			'setQueues',
			'setId',
			'getRealTime',
			'sendUnpause',
			'setChannel',
			'fetchClients',
			'fetchProtocol',
			'setShowSpearhead',
			'chooseClient',
			'chooseClientCnpj',
			'clearAllClients',
			'setCallTime',
			'setPauseTime',
			'saveProduct',
			'clearClient',
			'saveClient',
			'setShowBarRight',
			'checkTotalQUeues',
			'totalMyQueue',
			'setContacts',
			'chooseClientPhone',
			'setShowCommercialICampaign',
			'setShowCommercialIICampaign',
			'setShowCommercialIIICampaign',
			'setStartCampaign',
			'setCallData'
		]),
		...mapMutations([
				'setClient',
				'delDataConnectLine',
				'setMotivoPause'
		]),
		getStatusList() {
			axios.get("/listOptions").then(({ data }) => {
			// this.statusList = data;
			const obj = {};
			if (data.length > 0) {
				data.forEach((el) => {
					obj[el.id] = el.name;
				});
			}
				this.statusList = obj;
			});
		},
		validateTimePause() {
			this.time_pause = (this.getPauseTime != 'null') ? this.getPauseTime : 0;
			if(this.getPauseTime != 'null') {
				this.interval_pause = setInterval(() => {
					this.time_pause++;
				}, 1000);
			} 
			else {
				clearInterval(this.interval_pause);
			}
		},
		saveTabulacao() {
			const obj = {
				extension_line: this.hangupObj.dados[1],
				client_num: this.hangupObj.callerIdNum,
				status_id: this.selectedOption,
				status_owner: this.contactDono,
				uniqueid: this.hangupObj.uniqueid,
				call_time: (this.hangupObj && this.hangupObj.dados[2]) ? this.hangupObj.dados[2] : 0,
			};
			const request = axios
				.post("/createOption", obj)
				.then(({ data }) => {
					if (data) {
						return true;
				} else {
					return false;
				}
			});
			return request;
		},

		deletePopup(){
			const obj = {
				extension_line: this.ramal,
			};
			const request = axios.post("/deletePopup", obj)
				.then(({ data })=> {
					if(data){
						return true;
					} else {
						return false;
					}
			});
			return request;
		},

		updateTabulacao() {
			const obj = {
				uniqueid: this.hangupObj.uniqueid,
				status_id: this.selectedOption,
				status_owner: "NÃO INFORMADO",
				observacao: this.observacao,
			};
			const request = axios
				.put("/updateTabulacao", obj)
				.then(({ data }) => {
					if (data) {
						return true;
					} else {
						return false;
					}
				});
			return request;
		},
		historicol(event) {
			if(!this.getDeslog && !this.getShowHistory) {
				this.setShowHistory();
				this.fetchOcurrences(this.getCnpj);
			}
		},
		messages() {
			if(!this.getDeslog && !this.getMessages) this.setMessage();
		},
		discar(event) {
			this.settModalCall();
		},
		getTime() {
			var d = new Date();
			return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
		},
		pause() {
			this.queuePause = false;
			if(this.getPause == true) {
				connection.emit('QueueUnPause', {
					extension: user.getExtension()
				});

				this.closeCommercialCampaigns();
			}
			else {
				if(this.getDeslog == false) {
					this.setModalPause();
					this.fetchPauses();
				}
			}
		},
		/**
		 * Campanhas de ligação (Comercial I/II/III).
		 *
		 * A campanha é aberta pela pausa de mesmo nome e fechada ao sair dela.
		 * Todo o fluxo passa apenas pela telefonia — nada aqui depende do
		 * Whatsapp ou das filas de chat.
		 */
		isCommercialCampaignPause(pauseReason) {
			return commercialsICampaigns.includes(pauseReason)
				|| commercialsIICampaigns.includes(pauseReason)
				|| commercialsIIICampaigns.includes(pauseReason);
		},
		openCommercialCampaign(pauseReason) {
			if(commercialsICampaigns.includes(pauseReason) && !this.getShowCommercialICampaign) {
				this.setShowCommercialICampaign();
			}
			if(commercialsIICampaigns.includes(pauseReason) && !this.getShowCommercialIICampaign) {
				this.setShowCommercialIICampaign();
			}
			if(commercialsIIICampaigns.includes(pauseReason) && !this.getShowCommercialIIICampaign) {
				this.setShowCommercialIIICampaign();
			}
		},
		/**
		 * @param {boolean} restorePanel devolve a área principal ao atendimento
		 * online. Deve ser `false` quando quem chama já vai ajustar os painéis
		 * (por exemplo no logout da fila).
		 */
		closeCommercialCampaigns(restorePanel = true) {
			if(!this.getShowAnyCommercialCampaign) return;

			if(this.getShowCommercialICampaign) this.setShowCommercialICampaign();
			if(this.getShowCommercialIICampaign) this.setShowCommercialIICampaign();
			if(this.getShowCommercialIIICampaign) this.setShowCommercialIIICampaign();

			//DEVOLVE A ÁREA PRINCIPAL AO ATENDIMENTO ONLINE, QUE É O PADRÃO QUANDO LOGADO
			if(restorePanel && !this.getDeslog && !this.getMessages) this.setMessage();
		},
		/**
		 * Carrega quais tabulações significam "não atendido" (rediscagem) e quais
		 * significam agendamento. Os IDs vêm de at_option_status e variam por
		 * instalação, por isso são resolvidos pelo backend.
		 */
		getCampaignTabBehavior() {
			return axios.get('/campaignTabBehaviorCommercial')
				.then(({ data }) => {
					this.redialTabs = data.redial || [];
					this.scheduleTabs = data.schedule || [];
				})
				.catch(() => {
					this.redialTabs = [];
					this.scheduleTabs = [];
				});
		},
		/**
		 * Pede a data/hora do retorno quando a ligação da campanha é tabulada como
		 * agendamento. Sem isso o cliente nunca voltaria para a agenda.
		 */
		async askCampaignScheduleDatetime() {
			const minDatetime = moment().format('YYYY-MM-DDTHH:mm');

			const { value: scheduling } = await Swal.fire({
				type: "question",
				title: "Agendar retorno",
				html: `<p style="font-size: 14px; margin-bottom: 10px;">Escolha a data e a hora do retorno para este cliente.</p>
					<input id="campaign-schedule-input" type="datetime-local" class="swal2-input"
						min="${minDatetime}" value="${minDatetime}" style="width: 90%;">`,
				allowOutsideClick: false,
				allowEscapeKey: false,
				confirmButtonText: "Agendar",
				preConfirm: () => {
					const input = document.getElementById('campaign-schedule-input');
					const value = input ? input.value : '';

					if (!value) {
						Swal.showValidationMessage('Informe a data e a hora do retorno!');
						return false;
					}

					if (moment(value).isBefore(moment())) {
						Swal.showValidationMessage('O agendamento precisa ser no futuro!');
						return false;
					}

					return moment(value).format('YYYY-MM-DD HH:mm:ss');
				},
			});

			return scheduling || null;
		},
		agendamento() {
			this.setModalSchedule();
		},
		deslogar(){

			if(!this.telefone) return;
			var data = {
				queues: [user.getQueue()],
				extension: user.getExtension(),
			}

			if(this.getDeslog) {
				connection.emit('QueueAdd', data);
				if(!this.getMessages) this.setMessage();
			} 
			else {
				//DESLOGAR DA FILA ENCERRA QUALQUER CAMPANHA DE LIGAÇÃO EM ANDAMENTO
				this.closeCommercialCampaigns(false);

				if(this.getMessages) this.setMessage();
				if(this.getContacts) this.setContacts();
				if(this.getShowHistory) this.setShowHistory();

				connection.emit('QueueRemove', data);
			}
		},
		mute() {
			//HABILITANDO O MUTE APENAS SE ESTIVER EM LIGAÇÃO
			if(this.getChannel()) {
				this.setMute();

				//COLOCANDO NO LOCALSTORAGE PARA PEGAR INFORMAÇÃO DO MUTE QUANDO ATUALIZAR A PÁGINA
				(this.getMute == true)? localStorage.setItem("mute", "true") : localStorage.removeItem("mute") ;

				//CONTROLANDO SE É PARA COLOCAR O MUTE OU PARA TIRAR E ENVIANDO EMIT NECESSÁRIO
				var stateMute = (this.getMute == true)? 'on' : 'off' ;
				connection.emit('MuteAudio', {
					channel: this.getChannel(),
					extension: user.getExtension(),
					state: stateMute
				});
			}
		},
		async hangup() {
			connection.emit('hangup', {
				channel: this.getChannel()
			})

			//Limpa o canal
			await this.setChannel('');

			//Limpa o ponta de lanca
			await clientData.mutations.delDataConnectLine();
		},
		submitLogin(sub) {
			axios.post('/dialer/logs', { type: sub}).then((response) => {
					console.info(response);
			}, function(response) {
					console.error(response);
			});
		},
		contacts() {
			if(!this.getDeslog && !this.getContacts) this.setContacts();
        },
    },
    mounted: function() {
		this.checkTotalQUeues();
		this.totalMyQueue();

		window.addEventListener('beforeunload', this.deletePopup());

		this.getStatusList();
		this.getCampaignTabBehavior();

		// CAPTURANDO INFORMALÇÕES (SE ESTÁ EM LIGAÇÃO E SE ESTÁ LOGADO NA FILA)
		connection.emit('CoreShowChannels', {
			ramal: user.getExtension()
		});

		//EVENTO PARA CAPTURAR DADOS DE LIGAÇÃO EM CURSO DO OPERADOR LOGADO
		connection.on(`CoreShowChannel-${user.getExtension()}`, data => {			
			//HABILITANDO CONTADOR E PASSANDO PRO CONTADOR QUANTO TEMPO ESTA EM LIGAÇÃO
			this.setCallTime(moment.duration(data.Duration).asSeconds());

			//BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
			var self = this;

			this.fetchClients(data.ConnectedLineNum).then(async function() {
				//Recupera os dados tratado
				let phoneSplit = data.ConnectedLineName.split('||');
				let dataPhone = phoneSplit[1];

				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					// self.clearAllClients();
				} else {
					//SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			//SETANDO O CANAL DA LIGAÇÃO ATUAL
			this.setChannel(data.Channel);

			//HABILITANDO O MUTE NOVAMENTE CASO SEJA ATUALIZADO A PÁGINA
			(localStorage.getItem("mute") && this.getChannel() && this.getMute == false)? this.setMute() : false ;
		});

		//EVENT NECESSÁRIO PARA HABILITAR OS BOTÕES (LOGADO E PAUSA) QUANDO APESSOA ENTRA NA PAGINA
		connection.emit('QueueStatus', {
			ramal: user.getExtension()
		});

		//HABILITANDO OS BOTÕES NOVAMENTE CASO ESTEJA LOGADO... EM PAUSA...
		var validate = 0;
		connection.on(`QueueMember-${user.getExtension()}`, data => {
			if(validate == 0) {
				if(data.Paused == 1) {
					//INICIANDO CONTADOR DE PAUSA CASO ESTEJA EM PAUSA
					this.setPauseTime(data.LastPause);
					this.comeBack();
				}
				
				this.setDeslog();
				validate = 1
				this.queuesEsquerdo = true;
			}
		});

		//VALIDANDO QUANDO USUÁRIO É INSERIDO NA FILA
		connection.on(`QueueMemberAdded-${user.getExtension()}`, data => {
			if(!this.queuesEsquerdo) {
				this.setDeslog();
				this.startOrOut();
				this.submitLogin('LOGIN');
			}
			this.queuesEsquerdo = true;
		});

		//VALIDANDO QUANDO USUÁRIO É EXPULSO DA FILA
		connection.on(`QueueMemberRemoved-${user.getExtension()}`, data => {
			//EXPULSO DA FILA: ENCERRA QUALQUER CAMPANHA DE LIGAÇÃO EM ANDAMENTO
			this.closeCommercialCampaigns(false);

			if(this.getPause == true) {
				var time = this.getTime();
				var x = {
						"pauseId":id,
						"tempo":`${time}`,
						"userId":this.getId,
				}
				this.comeBack(`${time}`);
				this.sendUnpause(x);
			}

			if(this.queuesEsquerdo) {
				this.setDeslog();
				this.startOrOut();
				this.submitLogin('LOGOUT');
			}
			this.queuesEsquerdo = false;
		});

		// PEGANDO CANAL DO USUÁRIO EM LIGAÇÃO
		connection.on(`NewConnectedLine-${user.getExtension()}`, async data => {
			//O CLIENTE ATENDEU: DISPENSA A TABULAÇÃO AUTOMÁTICA DE "NÃO ATENDIDO"
			this.campaignClientAnswered = true;
			this.chooseClientPhone('');

			//Trata os dados
			await clientData.mutations.setDataConnectLine(data.ConnectedLineName);

			//Recupera os dados tratado
			let phoneSplit = data.ConnectedLineName.split('||');
			let dataPhone = phoneSplit[1];

			//INICIANDO O CONTADOR COM ZERO
			this.setCallTime(1);

			//BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
			var self = this;
			this.fetchClients(dataPhone).then(function() {
				if(self.allClients && self.allClients.length > 0) {
					self.chooseClient(self.allClients[0]);
					self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
					self.setShowSpearhead();
					self.clearAllClients();
				} 
				else {
					//SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
					self.chooseClient({
						at_user_id: '',
						birthday: '',
						cep: '',
						city: '',
						complement: '',
						cpf: '',
						created_at: '',
						email: '',
						id: '',
						name: '',
						neighborhood: '',
						number: '',
						phone: dataPhone,
						phone_2: '',
						reference: '',
						rg: '',
						street: '',
						updated_at: ''
					});
					self.setShowSpearhead();
				}
			});
			this.fetchProtocol();

			//SETANDO CANAL NO STATE
			this.setChannel(data.Channel);
		});

		//DESABILITANDO BOTÃO DE MUTE QUANDO FINALIZADO A LIGAÇÃO
		connection.on(`Hangup-${user.getExtension()}`, async data => {
			this.hangupObj["uniqueid"] = data.Linkedid;

			//LIMPA A TABULAÇÃO ANTERIOR: SEM ISSO A OBSERVAÇÃO DE UMA LIGAÇÃO VAZA
			//PARA A PRÓXIMA QUANDO O OPERADOR ESCOLHE UM STATUS QUE NÃO PERGUNTA
			this.selectedOption = "";
			this.contactDono = "";
			this.observacao = "";

			//A LIGAÇÃO FAZ PARTE DE UMA CAMPANHA DE LIGAÇÃO?
			const isCampaignCall = this.isCommercialCampaignPause(this.getMotivoPause);

			if(this.ramal != 4452){
				if (data.ConnectedLineName != "<unknown>") {
					let splitClientNum = data.ConnectedLineName.split("||");
					let clientNum = splitClientNum[1];
					this.hangupObj["dados"] = splitClientNum;
					this.hangupObj["callerIdNum"] = data.CallerIDNum;
					let splitTimeCall = data.ConnectedLineName.split("||");

					let timeCall = moment
						.utc(splitTimeCall[2] * 1000)
						.format("HH:mm:ss");

					timeCall = splitTimeCall[2] !== undefined ? timeCall : '0';
					const { value: option } = await Swal.fire({
						type: "question",
						title: "Como foi esta chamada?",
						allowOutsideClick: false,
						allowEscapeKey: false,
						html:
							"<b>Numero do Cliente: </b>" +
							clientNum +
							"<br>",
								// "<b>Tempo de ligação: </b>" +
								// timeCall,
							input: "select",
							inputPlaceholder: "Selecione o status",
							inputOptions: this.statusList,
							onOpen: () => {
								const statusVal = Swal.getInput();
								statusVal.addEventListener("change", () => {
									if (statusVal.value == 1) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Aceitou a oferta de matrícula</div>",
										});
									}

									if (statusVal.value == 2) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Agendou atend. presencial</div>",
										});
									}

									if (statusVal.value == 3) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Curso indisponível</div>",
										});
									}

									if (statusVal.value == 4) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Alto valor Financeiro</div>",
										});
									}
									if (statusVal.value == 5) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Forma de pagamento</div>",
										});
									}
									if (statusVal.value == 6) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Localização</div>",
										});
									}
									if (statusVal.value == 7) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Modalidade de Ensino</div>",
										});
									}
									if (statusVal.value == 8) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Foi para outra IES</div>",
										});
									}
									if (statusVal.value == 9) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Desistiu - Próximo semestre</div>",
										});
									}
									if (statusVal.value == 10) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Informações de cursos e valores</div>",
										});
									}
									if (statusVal.value == 11) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Inscrição duplicada</div>",
										});
									}
									if (statusVal.value == 12) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Inscrição realizada</div>",
										});
									}
									if (statusVal.value == 13) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Já é aluno da IES</div>",
										});
									}
									if (statusVal.value == 14) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Link pagamento enviado</div>",
										});
									}
									if (statusVal.value == 15) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Não responde - whats</div>",
										});
									}
									if (statusVal.value == 16) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Contato inexistente</div>",
										});
									}
									if (statusVal.value == 17) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Teste</div>",
										});
									}
									if (statusVal.value == 18) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Não Tabulado</div>",
										});
									}
									if (statusVal.value == 19) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Agendado</div>",
										});
									}
									if (statusVal.value == 20) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Perdida</div>",
										});
									}
									if (statusVal.value == 21) {
										Swal.update({
											html:
												"<b>Numero do Cliente: </b>" +
												clientNum +
												"<br>" +
												// "<b>Tempo de ligação: </b>" +
												// timeCall +
												// "<br>" +
												"<div style='padding-top: 20px; font-size: 15px'>✅Follow Up</div>",
										});
									}
								});
							},
							inputValidator: (value) => {
								if (!value) {
									return "Por favor, selecione uma das opções acima!";
								}
							},
						});
						if (option) {
							this.selectedOption = option;
							// Adiciona uma etapa para verificar se o usuário quer adicionar uma observação
							if (this.selectedOption !== "1") {
								const { value: addObservation } = await Swal.fire({
									type: "question",
									title: "Gostaria de adicionar uma observação?",
									allowOutsideClick: false,
									allowEscapeKey: false,
									input: "select",
									inputPlaceholder: "Selecione uma opção",
									inputOptions: {
										'Sim': 'Sim',
										'Não': 'Não'
									},
									inputValidator: (value) => {
										if (!value) {
											return "Por favor, selecione uma opção!";
										}
									}
								});

								// Se a resposta for "Sim", pede a observação
								if (addObservation === 'Sim') {
									const { value: observacao } = await Swal.fire({
										type: "question",
										title: "Digite a observação (máximo 100 caracteres)",
										allowOutsideClick: false,
										allowEscapeKey: false,
										input: "textarea",
										inputPlaceholder: "Digite sua observação aqui...",
										inputAttributes: {
											maxlength: 100 // Limite de 100 caracteres
										},
										inputValidator: (value) => {
											if (!value) {
												return "Por favor, insira sua observação!";
											}
										}
									});
									this.observacao = observacao;
								} else {
									this.observacao = "Nenhuma observação";
								}
							}
							if (this.saveTabulacao() && this.deletePopup() && this.updateTabulacao()){ //
								//CAMPANHA DE LIGAÇÃO: A TABULAÇÃO DO OPERADOR É A FONTE DE VERDADE
								if (isCampaignCall) {
									const campaignTab = parseInt(this.selectedOption);

									//TABULAÇÃO DE AGENDAMENTO PRECISA DA DATA DO RETORNO
									const schedulingDatetime = this.scheduleTabs.includes(campaignTab)
										? await this.askCampaignScheduleDatetime()
										: null;

									this.setCallData({
										call_id: data.Linkedid,
										tab: campaignTab,
										tab_obs: this.observacao || null,
										scheduling_datetime: schedulingDatetime,
									});
								}
								Swal.fire({
									position: "top-end",
									type: "success",
									title: "Tabulação realizada com Sucesso\n",
									showConfirmButton: false,
									timer: 1500,
								});
							} else {
								Swal.fire({
									position: "top-end",
									type: "error",
									title: "Não foi possivel salvar a tabulação\n",
									showConfirmButton: false,
									timer: 1500,
								});
							}
						}
					}
			}

			this.delDataConnectLine();
			this.setShowSpearhead();
			if(localStorage.getItem("mute")) {
				this.setMute()
				localStorage.removeItem("mute");
			}

			//CAMPANHA DE LIGAÇÃO: AVANÇA PARA O PRÓXIMO CLIENTE AO FIM DA LIGAÇÃO
			if (isCampaignCall) {
				//SÓ TABULA AUTOMATICAMENTE SE NINGUÉM ATENDEU E O OPERADOR NÃO TABULOU
				if (!this.campaignClientAnswered && !this.getCallData.tab && this.redialTabs.length) {
					this.setCallData({
						call_id: data.Linkedid,
						tab: this.redialTabs[0],
						tab_obs: "Não atendeu",
						scheduling_datetime: null,
					});
				}

				await Swal.fire({
					type: "info",
					title: "Atendimento finalizado!",
					text: "Clique em OK para avançar para o próximo atendimento.",
					allowOutsideClick: false,
					allowEscapeKey: false,
					confirmButtonText: "OK",
				});

				this.campaignClientAnswered = false;
				this.setStartCampaign();
			}

			//CADASTRANDO A LIGAÇÃO REALIZADA DO CLIENTE
			var structClient = {
				at_user_id: this.getId,
				protocol: this.getProtocol.protocol,
				uniqueid: data.Linkedid,
				type: 'telefonia',
				created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
				updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
			};

			structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
			this.saveClient(structClient);
			this.setCallTime('null');
			this.clearClient();
			this.clearAllClients();
			this.setChannel('');

			//LIMPANDO O CAMPO DE PRODUTO
			$('.select2-multi').val('-1').trigger('change');

			//Limpa o ponta de lanca
			await clientData.mutations.delDataConnectLine();
		});

		connection.on(`QueueMemberPause-${user.getExtension()}`, data => {
			if(this.queuePause) return;
			this.queuePause = true;

			// Entrou em pausa
			if(data.Paused == 1) {
				this.setPauseTime(0);
				var time = this.getTime();
				var x = {
					"pauseId": data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}

				this.sendPauseApi(x);
				this.selectPause(x);

				//PAUSA "COMERCIAL I/II/III" ABRE A CAMPANHA DE LIGAÇÃO CORRESPONDENTE
				this.openCommercialCampaign(data.PausedReason);
			}

			// Saiu da pausa
			if(data.Paused == 0) {
				var time = this.getTime();
				var x = {
					"pauseId":data.PausedReason,
					"tempo":`${time}`,
					"userId":this.getId,
				}

				this.comeBack(`${time}`);
				this.sendUnpause(x);
				this.setPauseTime('null');

				//SAIU DA PAUSA: ENCERRA A CAMPANHA DE LIGAÇÃO
				this.closeCommercialCampaigns();
			}
		});
    }
}

</script>

<style scoped>

	.blink-red {
			animation: blink-red 1s infinite;
	}

	@keyframes blink-red {
		0% { background-color: red; }
		50% { background-color: transparent; }
		100% { background-color: red; }
	}
    .num {
        width: 25px;
        height: 25px;
        text-align: center;
        text-combine-upright: all;
        left: 4em;
        border-radius: 50%;
        line-height: 25px;
        color: white;
        background-color: red;
        top: 5.5em;
        position: absolute;
    }

    .barra-lateral-esquerdo {
        background-color: #CCCCCC;
        width: 100%;
        max-width: 99px;
        text-align: center;
        border-right: solid 1px #1C869A;
         min-height: 100%;
        height: calc(100vh - 4.5em);
			overflow: auto;
    }

	::-webkit-scrollbar {
		width: 0.18rem;
	}

	::-webkit-scrollbar-track {
		background: #f38630;
	}

	::-webkit-scrollbar-thumb {
		background: #1c869a;
	}

    .figure-image {
        margin: 0px;
        display: block;
    }

    .figure-image div {
        margin: 0px;
        padding: 9px 0 9px 0;

    }

    .figure-image figcaption {
        color:white
    }

    .backGroundOrangeRed {
        background-color: orangered;
    }

    .backGroundOrange {
        background-color: #fea33b;
    }

    .bg-adv {
        background: #1c869a;
    }

    .backgroundGreen {
        background: #27ae60;
    }

    .count-msg {
        padding: 0px;
        color: white;
        font-size: 1.5em;
    }

    strong .count-msg {
        font-size: 1.5em;
    }

    .remove-padding {
        padding: 0 !important;
    }
</style>



